import React, { useState, useEffect } from "react";
import { Typography, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";

import CustomSearchBuyer from "../../components/Custom/CustomSearchBuyer";
import CustomTraceabilityDashboardCard from "../../components/Custom/CustomTraceabilityDashboardCard";
import { useNavigate } from "react-router-dom";

export default function TraceCrop() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [crops, setCrops] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadProduct = async () => {
      api.get("/buyer/sample-crops/").then((res) => {
        const _crops = res.data.map((f) => {
          const name = `${f.farmland?.farm_name}`;
          const cropName = `${f.commodity?.name}`;
          const date = f.sowing_date;
          const farmImage = f.sowing_file;
          return { id: f.id, farmName: name, cropName, date, farmImage };
        });
        setCrops(_crops);
      });
      setLoading(false);
    };

    loadProduct();
  }, []);

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "94vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontSize: "30px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            {t("Trace a Crop")}
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              mt: 2,
              fontSize: "15px",
              fontWeight: 400,
              marginTop: "10px",
            }}
          >
            {t("Enter link or code sent to you by the producer")}
          </Typography>

          <CustomSearchBuyer
            onSearch={(cropId) => navigate(`/view-crop/${cropId}`)}
            t={t}
            disableSearchOnType
          ></CustomSearchBuyer>

          {/* Use to display the logo if there is no data to display */}
          {/* {data.length === 0 && (
            <div
              style={{
                height: "74%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  margin: "auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={PlantBuyerIcon}
                  alt="Trace Crop Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />

                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, textAlign: "center" }}
                >
                  {t("Enter link or code to trace a Crop details")}
                </Typography>
              </div>
            </div>
          )} */}

          <Typography
            variant="subtitle2"
            sx={{ color: "#007D05", textAlign: "center", marginTop: "20px" }}
          >
            Sample Data
          </Typography>

          <Box sx={{ paddingBottom: "80px" }}>
            {crops.map((crop) => (
              <CustomTraceabilityDashboardCard
                key={crop.id}
                image={crop.farmImage}
                farmName={crop.farmName}
                cropName={crop.cropName}
                date={crop.date}
                onClick={() => {
                  navigate(`/view-crop/${crop.id}`);
                }}
              />
            ))}
          </Box>

          {/* {data.length !== 0 && (
            <div
              style={{
                height: "68%",
                marginTop: "20px",
                borderTop: "1px solid #A5A5A5",
                paddingTop: "20px",
                maxHeight: "68%",
                overflowY: "auto",
              }}
            >
              {details.map(({ label, value }, index) => (
                <React.Fragment key={index}>
                  <Grid container spacing={1} style={{ padding: "0 10px" }}>
                    <Grid item xs={6}>
                      <CustomLabel>
                        <Typography variant="body1" fontWeight="bold">
                          {label}:
                        </Typography>
                      </CustomLabel>
                    </Grid>
                    <Grid item xs={6}>
                      <CustomValue>
                        <Typography variant="body1">{value}</Typography>
                      </CustomValue>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}

              <Grid container spacing={0} style={{ marginTop: "40px" }}>
                <Grid item xs={12}>
                  <CustomTraceCropCard
                    detailsData={Pesticide}
                    t={t}
                    icon={FertilizersIcon}
                    label={"See Fertilizer and Pesticide"}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomTraceCropCard
                    detailsData={Pesticide}
                    t={t}
                    icon={LabTestIcon}
                    label={"See Lab Tests"}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomTraceCropCard
                    detailsData={Pesticide}
                    t={t}
                    icon={SatelliteDataIcon}
                    label={"See Satellite Data"}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomTraceCropCard
                    detailsData={Pesticide}
                    t={t}
                    icon={DecarbonizationIcon}
                    label={"See Decarbonization Efforts"}
                  />
                </Grid>
              </Grid>
            </div>
          )} */}
        </Container>
      </LoaderContainer>
    </>
  );
}
